import { useLoaderData, useOutletContext, Link, useNavigate } from "react-router-dom"
import DisplayCupBrowse from "../../track-components/DisplayCupBrowse";
import Button from "../../Button/Button";
import "./Profile.css";
import "../Browse/Browse.css";
import { useLayoutEffect, useState } from "react";
import SmallPop from "../../pops/SmallPop";

export default function Profile() {
    const data = useLoaderData();
    const [width, auth] = useOutletContext();
    const navigate = useNavigate();
    const [smallPop, setSmallPop] = useState();

    useLayoutEffect(() => {
        const timemout = setTimeout(() => {
            setSmallPop(null);
        }, 3500);

        return () => clearTimeout(timemout);
    }, [smallPop])

    return <div id="main-container">
        <div id="content-container">
            <div id="profile-container">
                <div id="name-container">
                    <h1>
                        {data?.displayName}
                    </h1>
                    {data?.id === auth.currentUser?.uid &&
                        <Button
                            text="Edit Profile"
                            onClick={(e) => {
                                e.preventDefault();
                                navigate(`/profile/${auth.currentUser.uid}/edit`)
                            }}
                        />}
                </div>
                <Button
                    icon={require("../../../assets/icons/icons8-share-50.png")}
                    text="Copy Link to Profile"
                    onClick={(e) => {
                        e.preventDefault();
                        navigator.clipboard.writeText("https://mk8dx-cup-builder.web.app"
                            + `/profile/${data.id}`);
                        setSmallPop(true);
                    }}
                />
            </div>

            <div id="pfp-user-cups">
                <h2>{data?.displayName}'s Cups:</h2>
                <ul id="cup-list">
                    {
                        data?.cups.map((element, index) => {
                            return <li key={index} tabIndex="-1" className="trackContainer">
                                <Link to={`/browse/cup/${element.id}`} reloadDocument>
                                    <h5 tabIndex={-1}>{element.cupName}</h5>
                                    <DisplayCupBrowse
                                        key={index}
                                        yourCup={false}
                                        editName={false}
                                        tracks={element.tracks}
                                        page="browse"
                                        width={width}
                                        showCursor={true}
                                    />
                                </Link>
                            </li>
                        })
                    }
                </ul>
            </div>
            {
                smallPop && <SmallPop text="Copied URL to clipboard!" />
            }
        </div>
    </div>
}